export default __webpack_public_path__ + "static/media/24_TopLeftSquares_Right.3284ffff.mp4";